import { render, staticRenderFns } from "./lv-table-column-space.vue?vue&type=template&id=cb95f322&"
import script from "./lv-table-column-space.vue?vue&type=script&lang=js&"
export * from "./lv-table-column-space.vue?vue&type=script&lang=js&"
import style0 from "./lv-table-column-space.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports